<template>
  <footer class="footer">
    <div class="box font-size-16">
      <p class="mb10">
        版权申明 | 使用条款ICP备案号：<a target="_blank" href="https://beian.miit.gov.cn?recordcode=31011202013410" >沪 ICP备 19001864号-1</a>
      </p>
      <p>©2019-2020 悟之信息科技（上海）有限公司</p>
      <div style="width:300px;margin:0 auto; padding:20px 0;">
        <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011202013410" 
          style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
          <img :src="require('@/assets/images/babh.png')" style="float:left;"/>
          <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">沪公网安备 31011202013410号</p>
        </a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
    data(){
        return{}
    }
};
</script>

<style lang="scss" scoped>
footer{
    display: flex;
    justify-content: center;
    width: 100%;
    height: 150px;
    color: #fff;
    letter-spacing: 1.5px;
    background-color: #166daf;
    .box {
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 30px;
        padding-bottom: 0;
    }
}
</style>
